import { render, staticRenderFns } from "./portfolioReview.vue?vue&type=template&id=a6b20d20&scoped=true&"
import script from "./portfolioReview.vue?vue&type=script&lang=ts&"
export * from "./portfolioReview.vue?vue&type=script&lang=ts&"
import style0 from "./portfolioReview.vue?vue&type=style&index=0&id=a6b20d20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b20d20",
  null
  
)

export default component.exports